// eslint-disable-next-line no-restricted-imports
import {observe} from '@github/selector-observer'
// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'
import poof from '../behaviors/confetti'
import {sendHydroEvent} from '../hydro-tracking'
import {wait} from '@github-ui/eventloop-tasks'

function setBillingReturnToUrl(privacyLevel: string, emailOptIn: string) {
  const elem = document.querySelector<HTMLElement>('.js-sponsorship-billing-details-dialog')
  if (!elem) {
    return
  }

  const dialogSource = elem.getAttribute('src')!
  const billingUrl = new URL(dialogSource, window.location.origin)
  const billingUrlParams = new URLSearchParams(billingUrl.search)
  const billingReturnTo = billingUrlParams.get('return_to') || ''
  const billingReturnToUrl = new URL(billingReturnTo, window.location.origin)
  const returnToParams = new URLSearchParams(billingReturnToUrl.search)
  const tierID = getCurrentOrFallbackUrlParam('tier_id', returnToParams)
  const editing = getCurrentOrFallbackUrlParam('editing', returnToParams)
  const sponsor = getCurrentOrFallbackUrlParam('sponsor', returnToParams)
  const amount = getCurrentOrFallbackUrlParam('amount', returnToParams)
  const frequency = getCurrentOrFallbackUrlParam('frequency', returnToParams)

  const newSearchParams = new URLSearchParams()
  newSearchParams.set('privacy_level', privacyLevel)
  newSearchParams.set('email_opt_in', emailOptIn)
  if (tierID) {
    newSearchParams.set('tier_id', tierID)
  }
  if (editing) {
    newSearchParams.set('editing', editing)
  }
  if (sponsor) {
    newSearchParams.set('sponsor', sponsor)
  }
  if (amount) {
    newSearchParams.set('amount', amount)
  }
  if (frequency) {
    newSearchParams.set('frequency', frequency)
  }

  const newReturnToPath = `${billingReturnToUrl.pathname}?${newSearchParams.toString()}`
  const encodedNewReturnTo = encodeURIComponent(newReturnToPath)
  const newReturnToUrl = new URL(newReturnToPath, window.location.origin)
  billingUrlParams.set('return_to', newReturnToUrl.toString())
  elem.setAttribute('src', `${billingUrl.pathname}?return_to=${encodedNewReturnTo}`)
}

function getCurrentOrFallbackUrlParam(paramName: string, fallbackParams: URLSearchParams): string | undefined | null {
  const defaultParams = new URLSearchParams(window.location.search)
  return defaultParams.get(paramName) || fallbackParams.get(paramName)
}

on('change', '.js-sponsorship-privacy-level', function (event) {
  const privacyLevel = (event.target as HTMLInputElement).value

  const emailOptInInput = document.querySelector<HTMLInputElement>('.js-sponsorship-email-opt-in')!
  const emailOptIn = emailOptInInput.checked ? 'on' : 'off'

  setBillingReturnToUrl(privacyLevel, emailOptIn)
})

on('change', '.js-sponsorship-email-opt-in', function (event) {
  const emailOptIn = (event.target as HTMLInputElement).checked ? 'on' : 'off'

  const privacyInputs = Array.from(document.querySelectorAll<HTMLInputElement>('.js-sponsorship-privacy-level'))
  const privacyInput = privacyInputs.find(input => input.checked)
  const privacyLevel = privacyInput ? privacyInput.value : 'public'

  setBillingReturnToUrl(privacyLevel, emailOptIn)
})

observe('.js-show-confetti-party', function (el) {
  poof()

  const dismissUrl = el.getAttribute('data-dismiss-url')
  if (dismissUrl) {
    const token = el.querySelector<HTMLInputElement>('.js-data-dismiss-url-csrf')!
    fetch(dismissUrl, {
      method: 'POST',
      mode: 'same-origin',
      headers: {
        'Scoped-CSRF-Token': token.value,
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
  }
})

const GOAL_PROGRESS_WAIT_TIME = 500
const GOAL_HEART_CONTAINER_WAIT_TIME = 450
const GOAL_HEART_EXPLOSION_WAIT_TIME = 100

async function animateSponsorsGoalImpact(el: Element) {
  // Animate progress bar change
  const progressBar = el.querySelector<HTMLElement>('.js-sponsors-goals-impact-progress-bar')!
  const percentageImpact = progressBar.getAttribute('data-percentage-impact')
  await wait(GOAL_PROGRESS_WAIT_TIME)
  if (percentageImpact) progressBar.style.width = `${percentageImpact}%`

  // Render heart container
  const heartContainer = el.querySelector<HTMLElement>('.js-sponsors-goals-impact-heart')
  if (!heartContainer) return
  await wait(GOAL_HEART_CONTAINER_WAIT_TIME)
  heartContainer.hidden = false
  heartContainer.classList.add('anim-scale-in')

  // Start heart explosion animation
  const heart = heartContainer.querySelector<HTMLElement>('.sponsors-goals-heart-anim')!
  await wait(GOAL_HEART_EXPLOSION_WAIT_TIME)
  heart.classList.add('is-active')
}

observe('.js-sponsors-goals-impact', function (el) {
  animateSponsorsGoalImpact(el)
})

observe('.js-sponsors-account-switcher', el => {
  el.addEventListener('toggle', ({target}) => {
    if (!(target instanceof HTMLElement)) {
      return
    }

    if (target.hasAttribute('open')) {
      sendHydroEvent(target)
    }
  })
})
